// extracted by mini-css-extract-plugin
module.exports = {"ekb-city":"ekb-city--1mAg4Huq","box-switch":"box-switch--1y-N4Bh2"};